import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import SpinnerCircular from './SpinnerCircular';
import { theme } from '../theme';
import styled from 'styled-components';

const ProtectedRoute = ({ children }) => {
  const { user, loading, token } = useAuth();
  const location = useLocation();

  if (loading) {
    // Muestra un spinner mientras se verifica el estado de autenticación
    return (
      <Loader>
        <SpinnerCircular
          size={30}
          thickness={180}
          speed={100}
          color={theme.fill.brandMain}
          secondaryColor={theme.fill.defaultWeak}
        />
      </Loader>
    )
  }

  if (!token || !user) {
    const returnTo = `${location.pathname}${location.search}${location.hash}`;

    return <Navigate to="/signin" state={{ returnTo }} replace />;
  }

  // Si está autenticado, renderiza el componente hijo (Outlet o children)
  return children ? children : <Outlet />;
};

export default ProtectedRoute;

const Loader = styled.div`
  align-items: center;
  display: flex;
  height: 100vh;
  justify-content: center;
  width: 100%;
`;
